import { cn } from '@/lib/utils'

/**
 * 지원 항목의 금액 신뢰도 배지.
 *
 * <p><b>주의가 필요한 것만 표시한다.</b> 확실한 금액(공단 고시 계산·시설 신고)에는
 * 배지를 달지 않는다 — 금액이 그 자체로 말하고 있는데 라벨까지 붙이면 화면이
 * 시끄러워지고, 정작 눈에 띄어야 할 「조건 확인 필요」·「지역마다 달라요」가 묻힌다.</p>
 *
 * <p>아이콘·이모지는 쓰지 않는다 — 1차 대상인 40~60대 보호자에게는 기호(💰 〜 ?)나
 * 아이콘의 관습이 즉시 읽히지 않는다. 한글 라벨만으로 뜻이 전달되도록 하고,
 * 테두리를 준 버튼 모양으로 눈에 띄게 한다.</p>
 */
const TIER_STYLE: Record<string, { label: string; tone: string; description: string }> = {
  /** 금액은 알지만 자격 조건이 붙음 */
  APPROX: {
    label: '조건 확인 필요',
    tone: 'border-amber-300 bg-amber-50 text-amber-800',
    description: '금액은 정해져 있지만 대상이 되시는지 확인이 필요해요',
  },
  /** 지자체 사업이라 지역마다 다름 */
  UNKNOWN: {
    label: '지역마다 달라요',
    tone: 'border-cb-gray-300 bg-cb-gray-50 text-cb-gray-700',
    description: '사시는 지역에 따라 달라요',
  },
}

export function tierDescription(tier: string): string {
  return TIER_STYLE[tier]?.description ?? ''
}

export default function BenefitTierBadge({ tier }: { tier: string }) {
  const style = TIER_STYLE[tier]
  if (!style) return null

  return (
    <span
      className={cn(
        // 40~60대 가독성 — 12px(text-caption) 대신 14px, 테두리로 버튼처럼 보이게
        'inline-flex flex-shrink-0 items-center rounded-lg border px-2.5 py-1 text-body-sm font-semibold',
        style.tone,
      )}
      title={style.description}
    >
      {style.label}
      <span className="sr-only"> — {style.description}</span>
    </span>
  )
}
